<div class="side-form-container">
    @if (share(); as sig) {
        <header class="fixed-height">
            Signed {{ docType | lowercase }}
            <button id="signed-quote-letter-side-form-close" (click)="close()" class="btn-flat square">
                <i class="fa-light fa-xmark"></i>
            </button>
        </header>
        <div class="card">
            <div class="viewer">
                <object class="pdf" #pdfView [data]="safePdfUrl()" type="application/pdf"></object>
                <div class="signature-details">
                    <img class="signature" [src]="sig.digitalSignature?.signatureBlobUrl" />
                    <p>
                        {{ docType }} was signed by {{ sig.digitalSignature?.approver?.email }} on
                        <span class="no-wrap">
                            {{ sig.digitalSignature?.signedAt | date: dateTimeFormat }}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    } @else {
        Loading...
    }
</div>
